import React from 'react';
import * as _ from 'lodash-es';
import { useUpdatePatientStatusContext } from 'components/modals/UpdatePatientStatusModal';
import { useMultiStep } from 'components/MultiStep';
import { ReferralStatus, ReferralStatusType } from 'global/referralStatus';
import { UpdateStatusLayout } from '../UpdateStatusLayout/UpdateStatusLayout';
import { UpdateStatusTile } from '../UpdateStatusTile/UpdateStatusTile';
import { StatusType } from '..';
import { subReferralStatuses } from './subReferralStatuses';

export const UpdatePatientSubStatus: React.FC = () => {
  const {
    referral,
    parentStatus,
    selectedStatus,
    setSelectedStatus,
    protocolsData,
    setCanNextStep,
  } = useUpdatePatientStatusContext();

  const { nextStep } = useMultiStep();
  const isRadioButtonDisabled = (key: string): boolean => {
    return key === 'APPOINTMENT_SCHEDULED' || false;
  };

  const dropReasons = referral?.screener?.dropReasonsAtSite;
  const failedIECriteriaDropReasons = dropReasons?.length
    ? dropReasons.filter((dr) => dr.statusType === 'IE_CRITERIA')
    : [];

  const notInterestedDropReasons = dropReasons?.length
    ? dropReasons.filter((dr) => dr.statusType === 'NOT_INTERESTED')
    : [];

  const getOnClickHandler = (status: ReferralStatusType) => {
    if (
      (selectedStatus ===
        ReferralStatus.DROPPED__FAILED_IN_EXCLUSION_CRITERIA &&
        failedIECriteriaDropReasons.length) ||
      (selectedStatus === ReferralStatus.DROPPED__NOT_INTERESTED &&
        notInterestedDropReasons.length)
    ) {
      setCanNextStep(true);
    } else {
      setCanNextStep(false);
    }

    if (
      status === ReferralStatus.APPOINTMENT_SCHEDULED ||
      (protocolsData?.protocolList.length && protocolsData?.protocolsCount > 0)
    ) {
      return () => {
        setSelectedStatus(status);
        nextStep();
      };
    }

    return () => setSelectedStatus(status);
  };

  return (
    <UpdateStatusLayout heading="">
      {_.map(
        subReferralStatuses[parentStatus],
        (status, key: ReferralStatusType) => {
          return (
            status && (
              <UpdateStatusTile
                key={key}
                value={key}
                checked={selectedStatus === key}
                onClick={getOnClickHandler(key)}
                onChange={() => {}}
                statusTitle={status.title}
                statusDescription={status.description}
                disabled={isRadioButtonDisabled(key)}
                statuesType={
                  selectedStatus === key
                    ? StatusType.SELECTED
                    : StatusType.UPCOMING
                }
                referralStatus={key}
              />
            )
          );
        }
      )}
    </UpdateStatusLayout>
  );
};
